// Return a random integer from 1, inclusive, through 6, inclusive.
export const makeCelebrationTitleKeyIndex = () => {
    const min = 1;
    const max = 6;
    return Math.floor(Math.random() * max + min);
};
